<script>
    import { navigateTo } from 'svelte-router-spa'
    import { soreThroat, bodyPains, headache, fever } from '../../store.js'

    let symptoms = {
        soreThroat: {
            name: 'Sore Throat',
            fil: 'Pananakit ng lalamuman/masakit lumunok'
        },
        bodyPains: {
            name: 'Body Pains',
            fil: 'Pananakit ng katawan'
        },
        headache: {
            name: 'Headache',
            fil: 'Pananakit ng ulo'
        },
        fever: {
            name: 'Fever for the past few days',
            fil: 'Lagnat sa mga nakalipas na araw'
        }
    }
    
    let currentSypmtom = 'soreThroat'
    let displaySymptom = symptoms.soreThroat

    function nxt(answer) {
         if (currentSypmtom === 'soreThroat') {
            soreThroat.set(answer)
            currentSypmtom = 'bodyPains'
            displaySymptom = symptoms.bodyPains
        } else if (currentSypmtom === 'bodyPains') {
            bodyPains.set(answer)
            currentSypmtom = 'headache'
            displaySymptom = symptoms.headache
        } else if (currentSypmtom === 'headache') {
            headache.set(answer)
            currentSypmtom = 'fever'
            displaySymptom = symptoms.fever
        } else if (currentSypmtom === 'fever') {
            fever.set(answer)
            navigateTo('exposure')
        }
    }

</script>

<main>
    <div class="body">
        <h2>Are you experiencing...</h2>
        <p>Nakakaranas ka ba ng...</p>

        <h1>{displaySymptom.name}</h1>
        <p>{displaySymptom.fil}</p>        
        <a class="btn" on:click={() => nxt('YES')}>
            <span class="e">Yes</span>
            <span class="f">Oo</span>
        </a>
        <a class="btn" on:click={() => nxt('NO')}>
            <span class="e">No</span>
            <span class="f">Hindi</span>
        </a>
    </div>
</main>

<style>
    h1 {
        color: var(--primary-color)
    }
</style>